import ImageUpload from "./ImageUploader";
import IcSwapFace from "./SwapFace.svg";
import './SwapFace.scss';
import {useAIToolsContext} from "../../../../../../../../../../context/AIToolsProvider";

const FaceSwap = () => {
  const {
    // FIRST SELECTED STATE
    firstSelectedImage,
    setFirstSelectedImage,

    firstBoundingBox,
    setFirstBoundingBox,
    firstBoundingBoxSelectedIndexes,

    setFirstBoundingBoxSelectedIndexes,

    firstSelectedImageServerPath,
    setFirstSelectedImageServerPath,

    // SECOND SELECTED STATE
    secondSelectedImage,
    setSecondSelectedImage,

    secondBoundingBox,
    setSecondBoundingBox,
    secondBoundingBoxSelectedIndexes,

    setSecondBoundingBoxSelectedIndexes,

    secondSelectedImageServerPath,
    setSecondSelectedImageServerPath,
  } = useAIToolsContext();

  const clearBoundingAndServerPath = () => {
    setFirstBoundingBox([]);
    setFirstBoundingBoxSelectedIndexes(null);
    setFirstSelectedImageServerPath(null);
    setSecondBoundingBox([]);
    setSecondBoundingBoxSelectedIndexes(null);
    setSecondSelectedImageServerPath(null);
  }

  const clearFirstImage = () => {
    setFirstSelectedImage(null);
    clearBoundingAndServerPath();
  }

  const clearSecondImage = () => {
    setSecondSelectedImage(null);
    clearBoundingAndServerPath();
  }

  return (
    <div className='swap-face-wrapper'>
      <ImageUpload
        inputId='first-image-upload' // id to trigger input tag, must be unique
        label="Upload from device"
        title="Upload an image (input image)"
        uploadedFile={firstSelectedImage}
        onUploadFile={setFirstSelectedImage}
        onDeleteFile={clearFirstImage}
        boundingBox={firstBoundingBox}
        boundingBoxSelectedIndexes={firstBoundingBoxSelectedIndexes}
        setBoundingBoxSelectedIndexes={setFirstBoundingBoxSelectedIndexes}
        swapFaceImagePath={firstSelectedImageServerPath}
        num={1}
        withPointer
        grid
        persistSize
        width={250}
        height={250}
      />

      <img src={IcSwapFace} alt='icon-swa' style={{marginTop: 32, marginBottom: 16}} />

      <ImageUpload
        inputId='second-image-upload' // id to trigger input tag, must be unique
        label="Upload from device"
        title="Upload an image you want to swap"
        uploadedFile={secondSelectedImage}
        onUploadFile={setSecondSelectedImage}
        onDeleteFile={clearSecondImage}
        boundingBox={secondBoundingBox}
        boundingBoxSelectedIndexes={secondBoundingBoxSelectedIndexes}
        setBoundingBoxSelectedIndexes={setSecondBoundingBoxSelectedIndexes}
        swapFaceImagePath={secondSelectedImageServerPath}
        num={2}
        withPointer
        grid
        persistSize
        width={250}
        height={250}
      />
    </div>
  );
};

export default FaceSwap;
